import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  headers: HttpHeaders;

  constructor(private http: HttpClient) {

    this.headers = new HttpHeaders({
      'Content-Type' : 'application/json' ,
      'Access-Control-Allow-Origin' : '*',
      'Access-Control-Allow-Methods' : 'POST,GET,PUT,DELETE, OPTIONS',
      'Access-Control-Allow-Headers' : 'Authorization, Lang'
    });
    this.headers.get('Content-Type');
    this.headers.get('Access-Control-Allow-Origin');
    this.headers.get('Access-Control-Allow-Methods');
    this.headers.get('Access-Control-Allow-Headers');
  }


  sendEmail(recipient: string, subject: string, content: string): Promise<any> {

    const url = 'https://us-central1-eatmatic-143319.cloudfunctions.net/httpEmail';
    const options = {
      headers: this.headers
    };
    const params = {
      to: recipient,
      from: 'scuverpt@gmail.com',
      subject,
      content,
    };

    return this.http.post(url, params, options).toPromise();
  }
}
